<template type="x/template">
  <transition name="modal" id="stock-transaction-dialog">
    <DxPopup
      id="dx-dialog"
      width="100vw"
      height="100vh"
      :hide-on-outside-click="false"
      :show-close-button="true"
      :visible="showPopup"
      :resize-enabled="false"
      :drag-enabled="false"
      @hidden="$emit('hidden')"
      :wrapper-attr="popupAttributes"
    >
      <template #title>
        <div class="transactions_header">
          <div class="left_side">
            <div @click="backButtonEvent" class="back_button" v-show="currentStep > -1">
              <img src="@/assets/images/icons/arrow-back.svg" />
              <div class="back_button_text">Înapoi</div>
            </div>
          </div>
          <div class="right_side">
            <img class="close_button" src="@/assets/images/icons/dialog-close.svg" @click="buttonCloseEvent" />
          </div>
        </div>
      </template>

      <template #content>
        <div class="transactions_content">
          <DxTabPanel
            ref="selectorTabPanel"
            :element-attr="tabPanelAttributes"
            :data-source="transactionSteps"
            :loop="false"
            :selected-item="currentItem"
            :selected-index="currentStep"
            :animation-enabled="true"
            :swipe-enabled="false"
            :show-nav-buttons="false"
            @selection-changed="tabSelectionChanged($event)"
          >
            <template #item="{ data: step }">
              <div class="transaction_tab_panels_container">
                <div class="dialog_title_container_field_report">
                  <div v-show="step == 1" class="title_text" :class="alignTitleLeft ? 'title_text_left' : 'title_text'">
                    {{ currentTransactionTitleText }}
                  </div>
                  <div class="transaction_sub_title_text field_report_sub_title_text">
                    {{ subtitleText1 }}<span style="color: #096c27">{{ subtitleText2 }}</span>
                  </div>
                </div>
                <div v-if="currentView === 'choose'" class="field_report_choice_screen consum_option_holder">
                  <div
                    v-for="option in fieldReportChoiceOptions"
                    :key="option.code"
                    class="field_report_selector_option"
                    @click="fieldReportChoiceClick(option.code)"
                  >
                    <div class="field_report_selector_option_icon">
                      <img :src="option.icon" :alt="$t(option.titleKey)" />
                    </div>
                    <div class="field_report_selector_option_content">
                      <div class="field_report_selector_option_title">{{ $t(option.titleKey) }}</div>
                      <div class="field_report_selector_option_subtitle">{{ $t(option.descriptionKey) }}</div>
                    </div>
                  </div>
                </div>
                <div v-else-if="currentView === 'existing-list'">
                  <search-input
                    :parentClass="'field_report_filter_search'"
                    placeholder="Caută ..."
                    @search="searchByText"
                  ></search-input>
                  <FieldReportList
                    ref="emptyWeightFieldReports"
                    :fillAtMount="true"
                    :filterData="emptyWeightReportsFilter"
                    :hasEstimatedWeight="0"
                    :isDeleted="0"
                    :userFilter="0"
                    :reportSelectMode="true"
                    @reportSelected="onExistingFieldReportSelected"
                  />
                </div>
                <div v-else-if="currentView === 'form'">
                  <FieldReport
                    ref="fieldReport"
                    @goBackParent="goBackParent"
                    @setTitle="setTitle"
                    :selectedFieldReportUuid="selectedFieldReportUuid"
                    :isEditMode="isEditMode"
                  ></FieldReport>
                </div>
              </div>
            </template>
          </DxTabPanel>
          <toast-message ref="toastMessage"></toast-message>
        </div>
      </template>
    </DxPopup>
  </transition>
</template>

<script>
import { DxPopup, DxPosition } from "devextreme-vue/popup";
import DxTabPanel from "devextreme-vue/tab-panel";
import FieldReport from "./partials/fieldReport.vue";
import FieldReportList from "../partials/fieldReportList.vue";
import SearchInput from "../../../components/Mobile/searchInput.vue";
import ToastMessage from "../../../components/Mobile/toastMessage.vue";

export default {
  name: "Transactions",
  props: {
    showPopup: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      popupAttributes: {
        class: "transaction_dialog_wrapper",
      },
      tabPanelAttributes: {
        class: "transaction_tabs",
      },
      transactionSteps: [1],
      currentStep: 0,
      currentItem: 1,
      currentTransactionTitleText: "",
      alignTitleLeft: false,
      subtitleText1: "",
      subtitleText2: "",
      currentView: "choose",
      fieldReportChoiceOptions: [
        {
          code: "new",
          titleKey: "field_report_mobile.transactions.choice_new_title",
          descriptionKey: "field_report_mobile.transactions.choice_new_description",
          icon: require("@/assets/images/icons/plus_green.svg"),
        },
        {
          code: "existing_empty_weight",
          titleKey: "field_report_mobile.transactions.choice_existing_empty_weight_title",
          descriptionKey: "field_report_mobile.transactions.choice_existing_empty_weight_description",
          icon: require("@/assets/images/icons/edit.svg"),
        },
      ],
      showFieldReport: false,
      showExistingReportsList: false,
      selectedFieldReportUuid: "",
      isEditMode: false,
      emptyWeightReportsFilter: {
        field_report: 1,
        has_estimated_weight: 0,
        finished_weighing: 0,
        find_all_fields: "",
      },
    };
  },
  components: {
    DxPopup,
    DxPosition,
    DxTabPanel,
    FieldReport,
    FieldReportList,
    SearchInput,
    ToastMessage,
  },
  watch: {
    showPopup(newVal) {
      if (!newVal) {
        this.showFieldReport = false;
        this.showExistingReportsList = false;
        this.currentView = "choose";
        this.selectedFieldReportUuid = "";
        this.isEditMode = false;
        this.resetForm();
      } else {
        this.currentView = "choose";
        this.showFieldReport = false;
        this.showExistingReportsList = false;
        this.selectedFieldReportUuid = "";
        this.isEditMode = false;
        this.currentTransactionTitleText = this.$t("field_report_mobile.transactions.title");
      }
    },
  },
  computed: {},
  methods: {
    backButtonEvent() {
      if (this.currentView === "existing-list") {
        this.showExistingReportsList = false;
        this.currentView = "choose";
        this.currentTransactionTitleText = this.$t("field_report_mobile.transactions.title");
        this.subtitleText1 = "";
        this.subtitleText2 = "";
        return;
      }

      if (this.currentView === "choose") {
        this.close();
        return;
      }

      try {
        this.$refs.fieldReport.goBack();
      } catch (e) {
        this.close();
      }
    },
    buttonCloseEvent() {
      if (this.currentView === "existing-list") {
        this.showExistingReportsList = false;
        this.currentView = "choose";
        this.currentTransactionTitleText = this.$t("field_report_mobile.transactions.title");
        this.subtitleText1 = "";
        this.subtitleText2 = "";
        return;
      }

      if (this.currentView === "choose") {
        this.close();
        return;
      }

      try {
        this.$refs.fieldReport.goBack();
      } catch (e) {
        this.close();
      }
    },
    close(message) {
      this.$emit("hidden");
      if (message && message.length > 0) {
        this.$emit("showTransactionMessage", message);
      }
    },
    tabSelectionChanged(e) {
      this.currentItem = e.addedItems[0];
      this.currentStep = this.transactionSteps.indexOf(this.currentItem);
    },
    searchByText(searchText) {
      this.$set(this.emptyWeightReportsFilter, "find_all_fields", searchText);
    },
    fieldReportChoiceClick(optionCode) {
      if (optionCode === "new") {
        this.startNewFieldReport();
      } else if (optionCode === "existing_empty_weight") {
        this.showExistingEmptyWeightReports();
      }
    },
    startNewFieldReport() {
      this.currentView = "form";
      this.showExistingReportsList = false;
      this.selectedFieldReportUuid = "";
      this.isEditMode = false;
      this.showFieldReport = true;
      this.currentTransactionTitleText = this.$t("field_report_mobile.transactions.title");
      this.subtitleText1 = "";
      this.subtitleText2 = "";
    },
    showExistingEmptyWeightReports() {
      this.currentView = "existing-list";
      this.showFieldReport = false;
      this.showExistingReportsList = true;
      this.selectedFieldReportUuid = "";
      this.isEditMode = true;
      this.currentTransactionTitleText = this.$t("field_report_mobile.transactions.select_existing_title");
      this.subtitleText1 = this.$t("field_report_mobile.transactions.select_existing_subtitle");
      this.subtitleText2 = "";
    },
    onExistingFieldReportSelected(fieldReport) {
      if (!fieldReport || !fieldReport.uuid) {
        return;
      }

      this.selectedFieldReportUuid = fieldReport.uuid;
      this.isEditMode = true;
      this.showExistingReportsList = false;
      this.currentView = "form";
      this.showFieldReport = true;
      this.currentTransactionTitleText = this.$t("field_report_mobile.transactions.title");
      this.subtitleText1 = "";
      this.subtitleText2 = "";
    },
    goBackParent(message) {
      if (this.currentStep <= 0) {
        this.close(message);
      } else {
        this.currentStep = this.currentStep - 1;
      }
    },
    setTitle(titleText, alignLeft, subt1 = "", subt2 = "") {
      this.currentTransactionTitleText = titleText;
      this.alignTitleLeft = alignLeft;
      this.subtitleText1 = subt1;
      this.subtitleText2 = subt2;
    },
    resetForm() {
      //this.$refs.fieldReport.resetForm();
      this.currentStep = 0;
      this.subtitleText1 = "";
      this.subtitleText2 = "";
      this.currentView = "choose";
      this.selectedFieldReportUuid = "";
      this.isEditMode = false;
      this.$set(this.emptyWeightReportsFilter, "find_all_fields", "");
    },
    showMessage(message) {
      this.$emit("showTransactionMessage", message);
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/stockMobile/transactions.scss";
</style>
